<template>
  <div id="home">
    <h1 class="title">{{ event.public_name }}</h1>

    <!-- <div class="box">Indicadors principals del esdeveniment</div> -->

    <div class="section-list">
      <div
        v-for="(item, index) in sections"
        class="section"
        :key="index"
        v-if="typeof item.visible === 'undefined' || item.visible"
      >
        <router-link :to="item.url" :event="item.disabled ? '' : 'click'">
          <div
            :class="
              'icon e' + event.type_id + ' ' + (item.disabled ? 'disabled' : '')
            "
          >
            <router-link :to="item.url + '/add'"
              ><div
                v-if="typeof item.add === 'undefined' || item.add"
                class="add"
              ></div
            ></router-link>
            <img class="img" :src="item.img" />
          </div>
          <div class="content">{{ item.name }}</div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from "@/i18n";

export default {
  name: "Home",
  components: {},
  data() {
    return {};
  },
  computed: {
    event() {
      var oEvent = this.$store.getters["events/getCurrentEvent"]();
      oEvent.public_name =
        typeof oEvent.name !== "undefined" &&
        typeof oEvent.edition !== "undefined"
          ? this.$root.formatEventName(oEvent.name, oEvent.edition)
          : "";
      return oEvent;
    },

    sections() {
      var oEvent = this.$store.getters["events/getCurrentEvent"]();
      var sections = [
        {
          url: (
            this.$root.formatEventUrl(oEvent.name, oEvent.edition) + "/club"
          ).replace("//", "/"),
          name: i18n.t("clubs.label"),
          img: "/img/club_2.svg",
          visible: !oEvent.is_campus,
        },
        {
          url: (
            this.$root.formatEventUrl(oEvent.name, oEvent.edition) + "/team"
          ).replace("//", "/"),
          name: i18n.t("teams.label"),
          img: "/img/team2.svg",
          visible: !oEvent.is_campus,
        },
        {
          url: (
            this.$root.formatEventUrl(oEvent.name, oEvent.edition) +
            "/competition"
          ).replace("//", "/"),
          name: i18n.t("competition.label"),
          img: "/img/competition.svg",
          visible: !oEvent.is_campus,
          add: false,
        },
        {
          url: (
            this.$root.formatEventUrl(oEvent.name, oEvent.edition) + "/person"
          ).replace("//", "/"),
          name: i18n.t("persons.label"),
          img: "/img/users.svg",
        },
        {
          url: (
            this.$root.formatEventUrl(oEvent.name, oEvent.edition) +
            "/volunteer"
          ).replace("//", "/"),
          name: i18n.t("volunteers.label"),
          img: "/img/users.svg",
          add: false,
        },
        {
          url: (
            this.$root.formatEventUrl(oEvent.name, oEvent.edition) +
            "/participants"
          ).replace("//", "/"),
          name: i18n.t("participants.label"),
          img: "/img/users.svg",
          visible: oEvent.is_campus,
        },
        {
          url: (
            this.$root.formatEventUrl(oEvent.name, oEvent.edition) + "/hotel"
          ).replace("//", "/"),
          name: i18n.t("hotels.label"),
          img: "/img/hotel.svg",
          add: false,
        },
        {
          url: (
            this.$root.formatEventUrl(oEvent.name, oEvent.edition) + "/facility"
          ).replace("//", "/"),
          name: i18n.t("facilitys.label"),
          img: "/img/court.svg",
        },
        {
          url: (
            this.$root.formatEventUrl(oEvent.name, oEvent.edition) + "/travel"
          ).replace("//", "/"),
          name: i18n.t("travels.label"),
          img: "/img/bus.svg",
        },
        {
          url: (
            this.$root.formatEventUrl(oEvent.name, oEvent.edition) + "/finances"
          ).replace("//", "/"),
          name: i18n.t("economy.label"),
          img: "/img/finance.svg",
          add: false,
        },
        {
          url: (
            this.$root.formatEventUrl(oEvent.name, oEvent.edition) + "/settings"
          ).replace("//", "/"),
          name: i18n.t("settings.label"),
          img: "/img/settings.svg",
          add: false,
        },
        {
          url: (
            this.$root.formatEventUrl(oEvent.name, oEvent.edition) + "/confirmations"
          ).replace("//", "/"),
          name: i18n.t("title_hotel_confirmations"),
          img: "/img/hotel_app.svg",
          add: false,
        },
        // {url: ( this.$root.formatEventUrl( oEvent.name, oEvent.edition ) +  '/documentation').replace( '//','/'), name: i18n.t( 'documentation.label' ), img: '/img/book.svg', disabled: false, add: true },
        // {url: ( this.$root.formatEventUrl( oEvent.name, oEvent.edition ) +  '/').replace( '//','/'), name: i18n.t( 'config.label' ), img: '/img/config.svg', disabled: true, add: false },
      ];

      return sections;
    },
  },
  created() {
    this.$store.commit("setTitle", "MIC");
    this.$overlay.hide();
  },
  methods: {
    loadDataPage() {
      var self = this;
      this.$store
        .dispatch("events/loadByName", this.$route.params.event)
        .then(function () {
          self.$overlay.hide();
          self.$store.commit("setEventSelected", true);
        });
    },

    clickDisabled(disabled, e) {
      alert("B");
      if (typeof disabled !== "undefined" && disabled) {
        alert("A");
        e.preventDefault();
        e.stopPropagation();
      }
    },
  },
  watch: {
    // call again the method if the route changes
    $route: "loadDataPage",
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

#container {
  overflow-y: auto !important;
}

#home {
  padding: 20px 30px;
  overflow-y: auto !important;

  .title {
    margin-top: 0;
    text-align: center;
  }

  .box {
    width: 100%;
    min-height: 300px;
    text-align: center;
    padding-top: 200px;
    margin-bottom: 100px;
    background: url("/img/loader.svg") no-repeat center center #eee;
    background-size: 80px;
    color: #888;
    font-size: 20px;
  }

  .section-list {
    width: 100%;
    position: relative;
    overflow: hidden;
    text-align: center;

    a {
      text-decoration: none;
    }

    .section {
      width: 125px;
      height: 125px;
      display: inline-block;
      margin: 0px 10px;
      margin-bottom: 35px;
      position: relative;
      text-align: center;

      .icon {
        width: 80%;
        height: 80%;
        border-radius: 50%;
        padding: 20px;
        position: relative;
        display: inline-block;
        background-color: #192461;
        border: 5px solid $main-color-t80;
        -webkit-transition: border 200ms ease-out;
        -moz-transition: border 200ms ease-out;
        -o-transition: border 200ms ease-out;
        transition: border 200ms ease-out;

        &.e1 {
          background-color: $main-color-e1;
        }
        &.e2 {
          background-color: $main-color-e2;
        }
        &.e3 {
          background-color: $main-color-e3;
        }
        &.e4,
        &.e12 {
          background-color: $main-color-e4;
        }
        &.e5 {
          background-color: $main-color-e5;
        }
        &.e13 {
          background-color: $main-color-e13;
        }
        &.e14 {
          background-color: $main-color-e14;
        }
        &.e15 {
          background-color: $main-color-e15;
        }
        &.e16 {
          background-color: $main-color-e16;
        }
        &.e17 {
          background-color: $main-color-e17;
        }
        &.disabled {
          opacity: 0.5;
        }

        .add {
          width: 30px;
          height: 30px;
          background: url("/img/add_2.svg");
          background-color: $complem-color;
          border-radius: 50%;
          border: 1px solid var(--main-color);
          position: absolute;
          top: -5px;
          right: -5px;
          content: " ";
          background-size: 20px;
          background-position: center;
          background-repeat: no-repeat;
          -webkit-transition: all 200ms ease-out;
          -moz-transition: all 200ms ease-out;
          -o-transition: all 200ms ease-out;
          transition: all 200ms ease-out;

          &:hover {
            width: 35px;
            height: 35px;
          }
        }

        &:hover {
          border: 8px solid $main-color-t80;
        }

        img {
          position: absolute;
          height: 50%;
          width: auto;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }

      .content {
        width: 100%;
        color: #192461;
        height: 30px;
        line-height: 30px;
        font-size: 18px;
        text-align: center;
        font-family: $text-light;
      }
    }
  }

  .events {
    margin-top: 50px;

    .event {
      .go {
        content: " ";
        width: 30px;
        height: 30px;
        background-image: url("/img/right-arrow.svg");
        background-size: 30px;
        background-position: center;
        position: absolute;
        top: 10px;
        right: 10px;
      }

      .logo {
        width: 100%;
        height: 150px;
        text-align: center;

        img {
          height: 100%;
          width: auto;
        }
      }

      .content {
        width: 100%;

        .title {
          text-align: center;
        }

        .subtitle {
          font-weight: lighter;

          strong {
            font-size: 16px;
            font-weight: bold;
          }
        }

        .stats {
          .stat {
            display: inline-block;

            .icon {
              height: 60px;

              img {
                height: 40px;
              }

              .label {
                font-size: 12px;
                font-weight: lighter;
              }
            }

            .value {
              margin-top: 10px;
              font-size: 18px;
              color: #acacac;
              line-height: 24px;

              .success {
                color: #000;
                font-weight: bold;
                font-size: 22px;
              }
            }

            &:not(:first-child) {
              border-left: 1px solid #ccc;
            }
          }
        }
      }
    }
  }
}
</style>
